/* eslint-disable max-statements */
/* eslint-disable no-mixed-spaces-and-tabs */
import { Fragment, useEffect, useRef, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import React from 'react';
import { QueryClient, QueryClientProvider, useMutation } from 'react-query';
import { SelectibleTopicCard } from './selectibleTopicCard';
import axios from 'axios';
import validator from 'validator';
import { useTypedSelector } from '../../../hooks/useTypeSelector';
import { globalEnv } from '../../../config/baseConfig';
import axiosInstance from '../../../config/axiosInstance';
import SaveButton from '../../Utils/saveButton';

const queryClient = new QueryClient();

type props = {
	userId: string;
	setOpen: (isOpen: boolean) => void;
	topics: any[];
	dashboards: any[];
	setDashboards: (dashboards: any) => void;

	isChanged: boolean;
	setIsChanged: (isChanged: boolean) => void;
	setIsWarnModalOpen: (isOpen: boolean) => void;
};

export default function DashboardAddModalContent({
	userId,
	setOpen: setModalOpen,
	topics: topics,
	dashboards,
	setDashboards,
	setIsChanged,
	isChanged,
	setIsWarnModalOpen
}: props) {
	const cancelButtonRef = useRef(null);
	const [isWarning, setIsWarning] = useState(false);
	const [addedTopics, setAddedTopics] = useState([]);
	const [name, setName] = useState('');
	const [isSaving, setIsSaving] = useState(false);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	useEffect(() => {
		addedTopics.length > 0 && setIsChanged(true);
	}, [addedTopics]);

	const save = () => {
		if (addedTopics.length > 0 && name !== '') {
			setIsSaving(true);
			createDashboard(userId);
		} else setIsWarning(true);
	};

	interface subscribeToTopics {
		userId: string;
	}

	const createDashboadReq = async (data: subscribeToTopics) => {
		const dto = {
			userId: data.userId,
			name: name,
			topics: addedTopics.map((topic) => topic)
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axiosInstance().post(
			globalEnv.BASE_URL + '/main/dashboard/create',
			dto,
			config
		);
		return response;
	};

	const { mutate } = useMutation(createDashboadReq, {
		onSuccess: (data) => {
			const dash = {
				_id: data._id,
				selectedTopics: data.selectedTopics,
				default: data.default,
				title: data.title
			};
			setDashboards([...dashboards, dash]);
			setIsChanged(false);
			setModalOpen(false);
		},
		onError: () => {
			setIsWarning(true);
			setIsSaving(false);
		}
		// onSettled: () => {
		// 	queryClient.invalidateQueries('create');
		// }
	});

	const createDashboard = (userId: string) => {
		mutate({ userId });
	};

	useEffect(() => {
		const timeout = setTimeout(() => {
			setIsWarning(false);
		}, 3000);

		return () => clearTimeout(timeout);
	}, [isWarning]);

	useEffect(() => {
		return () => {
			console.log('Unmount!');
		};
	}, []);

	return (
		<QueryClientProvider client={queryClient}>
			<div
				className="relative inline-block bg-white dark:bg-gray-800 rounded-lg text-left mt-10
                        shadow-xl transform transition-all align-middle ml-24
                        max-h-[80vh] overflow-hidden lg:w-11/12 w-9/12 my-10"
			>
				<section className="text-gray-700 overflow-scroll max-h-[72vh]">
					<div className="container px-5 sm:px-10 md:px-15 lg:px-20 mx-auto lg:pt-5 pt-3 lg :px-32">
						<h3 className="lg:text-6xl text-4xl font-semibold text-gray-800 dark:text-white text-center">
							Add Dashboard
						</h3>
						<div className="border-t mt-3 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center"></div>

						<div className="mt-5 w-10/12 max-w-lg">
							<h3 className="block mb-2 text-sm font-medium text-gray-800 dark:text-gray-300">
								Dashboard name
							</h3>
							<input
								type="text"
								id="name"
								className="bg-gray-50 border border-gray-500 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
								placeholder="Personal"
								required
								onChange={(e) => {
									setName(e.target.value);
									setIsChanged(true);
								}}
							/>
						</div>

						<div className="border-t mt-3 border-gray-300 dark:border-gray-700 transition-all duration-500 text-center"></div>

						<h3 className="block mt-5 text-sm font-medium text-gray-800 dark:text-gray-300">
							Selected topics
						</h3>
						<div className="w-full mt-2">
							<div className="carousel p-4 bg-gray-300 dark:bg-gray-700 rounded-box text-center">
								{topics.map((item: any) => (
									<SelectibleTopicCard
										key={item._id}
										id={item._id}
										name={item.name}
										image={item.backgroundImage}
										addedTopics={addedTopics}
										setAddedTopics={setAddedTopics}
									/>
								))}
							</div>
						</div>
					</div>
				</section>

				<div className="bg-white dark:bg-gray-800 px-8 pb-3 sm:px-6 flex flex-row-reverse">
					{addedTopics.length > 0 && !validator.isEmpty(name) && (
						<SaveButton isSaving={isSaving} saveFunc={() => save()} />
					)}
					<button
						type="button"
						className="btn btn-outline btn-sm btn-error mr-2"
						onClick={() => {
							if (isChanged) setIsWarnModalOpen(true);
							else setModalOpen(false);
						}}
						ref={cancelButtonRef}
					>
						Cancel
					</button>
				</div>
			</div>
		</QueryClientProvider>
	);
}
